import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const FabricBanners = () => {

    const servicesFaqData = [
        {
            question: "What customisation options are available for fabric banner printing?",
            answer: "Printingy offers extensive customisation for Custom Fabric Designer Banners Printing, including sizes, finishes, and fabric types. You can add logos, graphics, and text in vibrant colours tailored to your branding and promotional needs."
        },
        {
            question: "Does Printingy handle bulk orders for fabric banners?",
            answer: "We specialise in bulk fabric banner printing, providing cost-effective solutions for large-scale promotions, events, and exhibitions. Bulk orders ensure consistent quality and competitive pricing."
        },
        {
            question: "What materials are used for fabric banners?",
            answer: "We use high-quality, wrinkle-resistant, and weatherproof materials for cloth banner printing. These fabrics ensure durability, making them suitable for indoor and outdoor use while maintaining a premium appearance."
        },
        {
            question: "What industries benefit from fabric banner printing services?",
            answer: "Fabric banners are widely used in events, retail, hospitality, and corporate branding industries. Businesses use customised fabric banner printing for trade show displays, event backdrops, and promotional advertising."
        },
        {
            question: "Can I print custom designs and logos on fabric banners?",
            answer: "Absolutely. Our Custom Fabric Designer Banners Printing allows you to include logos, text, and unique graphics. We ensure precise, high-resolution printing that aligns with your brand’s requirements."
        },
        {
            question: "What is the turnaround time for bulk fabric banner printing?",
            answer: "Turnaround times for Printing Fabric Banners depend on the order size and design complexity. Bulk orders are typically completed within a few business days, ensuring timely delivery for events or campaigns."
        },
        {
            question: "Are the fabric banners reusable and easy to maintain?",
            answer: "Yes, our fabric banners are durable, wrinkle-resistant, and reusable. They are easy to clean, making them ideal for repeated use at events, exhibitions, or promotions."
        },
        {
            question: "Do you provide design assistance for fabric banners?",
            answer: "Yes, Printingy offers design support for customised fabric banner printing. Our team collaborates with you to finalise layouts, colours, and graphics, ensuring your banners reflect your branding goals."
        },
        {
            question: "What makes fabric banners ideal for events?",
            answer: "Fabric banners are lightweight, durable, and visually appealing, perfect for events, trade shows, and promotions. Their wrinkle-free nature and vibrant graphics ensure a professional presentation every time."
        },
        {
            question: "How do I place an order for custom fabric banner printing?",
            answer: "Placing an order is simple. Visit our website, select your preferences for fabric banner printing, and upload your artwork, and our team will guide you through the design and delivery process."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Fabric Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Fabric Banners Printing Services for Events and Promotions"
  description="Professional printing of fabric, cloth, and custom fabric designer banners. Bulk customised fabric banner printing solutions for branding and events."
  keywords="Printing of Fabric Banners,
Fabric Banners Printing,
Custom Fabric Designer Banners Printing,
Cloth Banner Printing,
Customised Fabric Banner Printing
"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Fabric Banners</h1>
              <h2 className="text-muted">
              Custom fabric designer banners and cloth banner printing for events 
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Fabric banners are a premium solution for showcasing messages, branding, and promotions at events, exhibitions, and retail spaces. Printingy specialises in Printing Fabric Banners, providing high-quality fabric banner printing and cloth banner printing tailored to your requirements.</p>
          <p>Our Custom Fabric Designer Banners Printing ensures vibrant visuals, sharp graphics, and durable materials that stand out. With customised fabric banner printing, we offer fully tailored sizes, finishes, and designs to match your branding goals.</p>
          <p>Perfect for trade shows, corporate events, or retail displays, Printingy’s fabric banners combine durability with elegance, delivering reliable solutions for all your bulk printing needs.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Fabric Banner Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and vibrant fabric banners for events and branding</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Fabric Banners for indoor and outdoor displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional fabric banner printing with vibrant colours and precise details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised Custom Fabric Designer Banners Printing to suit your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials, including wrinkle-resistant and weatherproof fabrics.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Cost-effective cloth banner printing for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensures long-lasting quality.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk orders and urgent requirements.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by event organisers, exhibitors, and businesses nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/fabricbannerss.jpg" // Path relative to the public folder
                  alt="High-quality fabric banner printing solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
        title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Fabric Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your banner printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with premium fabrics to provide exceptional customised fabric banner printing services. Our fabric banner printing guarantees sharp visuals and durable results for retail branding, trade shows, or corporate events.</p>
            <p>Our streamlined production process ensures quick turnarounds, even for bulk orders. Partner with Printingy to create professional and impactful fabric banners that elevate your promotional displays.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default FabricBanners;
